import { axiosGet, axiosPost, axiosDelete, handleOnError } from '../utils/api';

class CountriesService {
    // all countries with file-usage counts + deletable flag
    async getCountries() {
        try {
            let response = await axiosGet('countries');
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // add a new country
    async createCountry(payload) {
        try {
            let response = await axiosPost('countries', payload);
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // set the global default country
    async setDefault(code) {
        try {
            let response = await axiosPost(`countries/${code}/default`, {});
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // delete a country (server blocks if files are associated or it's the default)
    async deleteCountry(code) {
        try {
            let response = await axiosDelete(`countries/${code}`);
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }
}

export default new CountriesService();
